import React, { Component } from "react";
import { connect } from "react-redux";
import Moment from "moment";
import Config from "../../config";
import withStyles from "@material-ui/core/styles/withStyles";
import { GlobalState } from "../../types/globalState";
import { Hole, Player } from "../../types/player";
import { Check, Close, Edit } from "@material-ui/icons";
import {
  Button,
  IconButton,
  createStyles,
  FormControl,
  FormControlLabel,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  WithStyles,
  Dialog,
} from "@material-ui/core";
import GamesActions from "../../actions/games";
import { HoleParam } from "../../types/hole";
import { StyledTableRow, TightBodyCell, TightHeaderCell } from "../SharedComponents/CustomTableElements";
import { Game, GState } from "../../types/game";
import GrossPickerDialog from "../Game/GrossPickerDialog";
import GameCodeCapsule from "../Game/GameCodeCapsule";
import ScoreAPi from "../../api/scores";
import { TextInput } from "../SharedComponents/TextInput";
import { filter } from "../../utils/profanityFilter";
import { showSnackbar } from "../SharedComponents/Notifier";
import _ from "lodash";
import { ErrorOnlyCallback } from "../../types/actions";
import { User } from "../../types/user";
import { HoleSigns } from "../../types/hole";
import { getHandicapDisplay, isCombinedGame } from "utils";
import PlayerName from "components/SharedComponents/PlayerName";
import { hcpConvertor } from "utils/hcpConvertor";

interface Props extends WithStyles {
  dangerouslyUpdateScore(
    gameId: string,
    playerId: string,
    scoreId: string,
    data: any,
    holes: any,
    callback?: ErrorOnlyCallback,
  ): void;
  player: any;
  loading: any;
  game: any;
  user: User;
  closeDialog: VoidFunction;
}
interface State {
  [inde: string]: any;
  game: Game;
  reason: string;
  comments: string;
  nofinish: boolean;
  disqualified: boolean;
  openPickerDialog: boolean;
  pickerHoleParams: HoleParam;
  hcp: string;
  hci: string;
  err_comments: boolean;
  err_hcp: boolean;
  selectedScorerId: string;
}
enum VerifyStatus {
  VERIFIED,
  MANUALY_VERIFIED,
  UNVERIFIED,
}

const MetaField = ({
  label,
  children,
  classes,
  wide,
  className,
}: {
  label: string;
  children: React.ReactNode;
  classes: Record<string, string>;
  wide?: boolean;
  className?: string;
}) => (
  <div
    className={[classes.metaField, wide ? classes.metaFieldWide : "", className || ""]
      .filter(Boolean)
      .join(" ")}
  >
    <span className={classes.metaLabel}>{label}</span>
    <div className={classes.metaValue}>{children}</div>
  </div>
);

class ScoreCardSubmition extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const player = props.game!.players[props.player._id];
    const selectedScorerId: any = _.isEmpty(player.uholes)
      ? Object.keys(props.game.players)[0]
      : this.getFirstholeScorer(player.uholes, props.game!.players);
    this.state = {
      game: { ...props.game },
      reason: player.reason ? player.reason : "",
      comments: player.comments ? player.comments : "",
      nofinish: player.nofinish ? player.nofinish : false,
      disqualified: player.disqualified ? player.disqualified : false,
      openPickerDialog: false,
      pickerHoleParams: {} as HoleParam,
      hcp: getHandicapDisplay(player.hcp),
      hci: getHandicapDisplay(player.hci),
      err_comments: false,
      err_hcp: false,
      selectedScorerId: selectedScorerId,
    };

    console.log({ player: this.props.player, game: this.props.game });
  }

  getFirstholeScorer = (uholes: any, players: { [index: string]: Player }) => {
    const firstHole = Object.keys(uholes)[0];
    const firstScorerPlayer = Object.keys(uholes[firstHole].grosses)[0];
    //If organizer who hasn't joined the game, used QS
    return players[firstScorerPlayer] ? firstScorerPlayer : Object.keys(players)[0];
  };

  summation(holeParams: HoleParam[], key: string): number {
    let sum = 0;
    Object.values(holeParams).forEach((param: HoleParam) => {
      if (param[key] && typeof param[key] === "number") {
        sum += param[key] as number;
      }
    });
    return sum;
  }

  getStartingHoleIndex = (): number => {
    const player = this.getPlayer();
    if (player && player.group && player.group.startingHole) {
      return player.group.startingHole - 1;
    }
    return 0;
  };
  getGame = (): Game => {
    return this.state.game;
  };
  getPlayer = (): Player | null => {
    const game = this.getGame();
    const { player } = this.props;
    if (!game) return null;
    return game!.players[player._id];
  };
  getScoreCard = () => {
    const { user, player } = this.props;
    const game = this.getGame();
    const startingHoleIndex = this.getStartingHoleIndex();
    if (user && game && game.scoreCards) {
      const cardId = game.players[player._id].teeColor ? game.players[player._id].teeColor.scoreCardId : null;
      let sc: any = { ...Object.values(game.scoreCards)[0] };
      if (cardId) sc = { ...game.scoreCards.find(x => x._id === cardId) };
      if (sc.holesParams) {
        sc.holesParams = [...sc.holesParams.slice(startingHoleIndex), ...sc.holesParams.slice(0, startingHoleIndex)];
      }
      return sc;
    }
    return null;
  };
  getScoringFormat = () => {
    const game = this.getGame();
    return typeof game?.competition === "object" ? game.competition.scoringFormat.toString() : "undefined";
  };

  _handleChangeReason = (event: any) => {
    this.setState({ reason: event.target.value });
  };
  handleChangeScorer = (event: any) => {
    this.setState({ selectedScorerId: event.target.value });
  };
  _handleCommentsChange = (value: string, name: string) => {
    this.setState({ [name]: value });
  };

  _handleHandicapIndexChange = (evt: React.FormEvent<HTMLDivElement>) => {
    const target = evt.currentTarget as HTMLDivElement;
    let text = target.textContent || "";

    // 1. Filter out completely disallowed characters (allow only digits, '.', '+')
    let sanitizedText = text.replace(/[^0-9.+]/g, "");

    // 2. Enforce structure:
    //    - '+' only one allowed, and only at the beginning.
    if (sanitizedText.includes("+")) {
      if (sanitizedText.startsWith("+")) {
        // If it starts with '+', remove all other '+' from the rest of the string
        sanitizedText = "+" + sanitizedText.substring(1).replace(/\+/g, "");
      } else {
        // If '+' is present but not at the start, remove all '+'
        sanitizedText = sanitizedText.replace(/\+/g, "");
      }
    }

    //    - '.' only one allowed.
    const dotIndex = sanitizedText.indexOf(".");
    if (dotIndex !== -1) {
      // If a dot exists, remove all subsequent dots from the part after the first dot
      sanitizedText =
        sanitizedText.substring(0, dotIndex + 1) + sanitizedText.substring(dotIndex + 1).replace(/\./g, "");
    }

    // 3. Update the div's content if it changed after sanitization
    // This makes the div visually reflect the allowed characters and structure.
    if (target.textContent !== sanitizedText) {
      target.textContent = sanitizedText;
      // After setting textContent, the browser usually moves the cursor to the end.
      // Manage cursor position for better UX.
      if (target.childNodes.length > 0 && window.getSelection) {
        const range = document.createRange();
        const sel = window.getSelection();
        // Use the last child node for positioning
        const lastChild = target.childNodes[target.childNodes.length - 1];
        const length = lastChild.textContent?.length || 0;
        range.setStart(lastChild, Math.min(length, sanitizedText.length));
        range.collapse(true);
        if (sel) {
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    }

    // Update state only if the sanitized text is different from the current state.hci
    // to prevent unnecessary re-renders or potential loops.
    if (this.state.hci !== sanitizedText) {
      this.setState({ hci: sanitizedText });
    }
  };

  _handleHandicapChange = async (event: React.FormEvent<HTMLDivElement>) => {
    const target = event.currentTarget as HTMLDivElement;
    let text = target.textContent || "";

    // 1. Filter out completely disallowed characters (allow only digits, '.', '+')
    let sanitizedText = text.replace(/[^0-9.+]/g, "");

    // 2. Enforce structure:
    //    - '+' only one allowed, and only at the beginning.
    if (sanitizedText.includes("+")) {
      if (sanitizedText.startsWith("+")) {
        // If it starts with '+', remove all other '+' from the rest of the string
        sanitizedText = "+" + sanitizedText.substring(1).replace(/\+/g, "");
      } else {
        // If '+' is present but not at the start, remove all '+'
        sanitizedText = sanitizedText.replace(/\+/g, "");
      }
    }

    //    - '.' only one allowed.
    const dotIndex = sanitizedText.indexOf(".");
    if (dotIndex !== -1) {
      // If a dot exists, remove all subsequent dots from the part after the first dot
      sanitizedText =
        sanitizedText.substring(0, dotIndex + 1) + sanitizedText.substring(dotIndex + 1).replace(/\./g, "");
    }

    // 3. Update the div's content if it changed after sanitization
    // This makes the div visually reflect the allowed characters and structure.
    if (target.textContent !== sanitizedText) {
      target.textContent = sanitizedText;
      // After setting textContent, the browser usually moves the cursor to the end.
      // To ensure this, and handle cases where target might not have a simple text node:
      if (target.childNodes.length > 0 && window.getSelection) {
        const range = document.createRange();
        const sel = window.getSelection();
        // Use the last child node for positioning, common for simple text in contentEditable
        const lastChild = target.childNodes[target.childNodes.length - 1];
        const length = lastChild.textContent?.length || 0;
        range.setStart(lastChild, Math.min(length, sanitizedText.length)); // Ensure position is within bounds
        range.collapse(true);
        if (sel) {
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    }
    const rawInput = sanitizedText; // This is what's currently (and correctly) in the div

    // Update the hcp state with the current, sanitized content of the div.
    // This ensures the state reflects what the user sees, even if it's not yet calculation-ready.
    // Only update if it's different from the current state to avoid unnecessary re-renders/effects.
    if (this.state.hcp !== rawInput) {
      this.setState({ hcp: rawInput });
    }

    // If rawInput is empty after sanitization, just ensure state is empty and stop.
    if (rawInput === "") {
      return;
    }

    // Regex for a format that is ready for calculation (e.g., "+1.7", "1.7", "0", "+0")
    // Does not match: "+", "1.", ".7"
    const calculationReadyFormat = /^(?:\+)?\d+(?:\.\d)?$/;

    if (calculationReadyFormat.test(rawInput)) {
      const player = this.getPlayer();
      if (!player) return;

      // `rawInput` (e.g., "+1.7" or "1.7") is passed to `recalculatePoints`.
      // `recalculatePoints` uses `hcpConvertor` which should handle "+1.7" -> "-1.7" (string)
      const points = await this.recalculatePoints(player.holes, rawInput);

      this.setState((state: State) => ({
        ...state,
        // hcp: rawInput, // Already updated if changed
        game: {
          ...state.game,
          players: {
            ...state.game.players,
            [player._id]: {
              ...state.game.players[player._id],
              points: points,
            },
          },
        },
      }));
    } else {
      // The input is sanitized (e.g., "+", "1.") but not yet in a "calculation-ready" format.
      // `this.state.hcp` reflects this intermediate state. No points recalculation yet.
    }
  };

  _handleSwitchChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ [field]: event.target.checked as boolean });
  };

  recalculatePoints = async (holes: any, hcp: string) => {
    const game = this.getGame();
    if (!game) return;

    const scoreCard = this.getScoreCard();
    return (
      await ScoreAPi.calculateScores(game._id, scoreCard._id, Object.values(holes), parseFloat(hcpConvertor(hcp)))
    ).data;
  };

  _updateHoles = (
    gross: any,
    holeNumber: number,
    holesCount: number,
    dnfSelected: boolean,
    holesObj: Hole,
    playersId?: string[],
  ) => {
    const holes: { [index: number]: any } = {};
    const allHoles = Array.from({ length: holesCount }, (_, i) => i + 1);

    const fillScores = (holeNumbers: number[], g: any) => {
      holeNumbers.forEach(i => {
        holes[i] = {
          gross: g,
          holeNumber: i,
          ...(playersId
            ? {
                grosses: {
                  ...playersId.reduce(
                    (acc, id) => ({
                      ...acc,
                      [id]: g,
                    }),
                    {},
                  ),
                },
              }
            : {}),
        };
      });
    };

    console.log("UPDATE HOLES");

    // DNP
    if (gross === HoleSigns.DNP) {
      const remainingHoles = allHoles.filter(h => holesObj[h]?.gross === undefined);
      fillScores(remainingHoles, gross);
    }
    // DNF
    else if (dnfSelected) {
      fillScores([holeNumber], HoleSigns.DNF);
      const remainingHoles = allHoles.filter(h => holesObj[h]?.gross === undefined && h !== holeNumber);

      fillScores(remainingHoles, HoleSigns.DNP);
    } else {
      fillScores([holeNumber], gross);
    }

    return holes;
  };

  _handleGrossChange = async (teePlayer: Player | null, holeNumber: number, gross: any, dnfSelected: boolean) => {
    const game = this.getGame();
    const player = this.getPlayer();
    if (!player) return;
    if (gross !== "PU" && gross !== "DNF" && gross !== "DNP") gross = parseInt(gross);

    const { hcp } = this.state;

    const holes = {
      ...player.holes,
      ...this._updateHoles(gross, holeNumber, game.competition.holesNumber, dnfSelected, player.holes),
    };

    let uholes = { ...(player.uholes || {}) };

    if (isCombinedGame(game.competition)) {
      if (!teePlayer) return;

      uholes = {
        ...uholes,
        ...this._updateHoles(gross, holeNumber, game.competition.holesNumber, dnfSelected, player.holes, [
          teePlayer._id,
        ]),
      };
    } else {
      const scorers = uholes[1] && uholes[1].grosses ? Object.keys(uholes[1].grosses) : [this.state.selectedScorerId];
      // const grosses = uholes[1] && uholes[1].grosses ? uholes[1].grosses : {};
      uholes = {
        ...uholes,
        ...this._updateHoles(gross, holeNumber, game.competition.holesNumber, dnfSelected, player.holes, scorers),
      };
    }

    const points = await this.recalculatePoints(holes, hcp);
    this.setState((state: State) => {
      return {
        ...state,
        game: {
          ...state.game,
          players: {
            ...state.game.players,
            [player._id]: {
              ...state.game.players[player._id],
              points,
              holes,
              uholes,
            },
          },
        },
      };
    });
  };

  _submitForm = () => {
    // Regex for validating the display format of handicaps (e.g., "+1.7", "10", "0.5")
    // Allows an optional '+', 1 or 2 digits, then an optional decimal point followed by 1 digit.
    const handicapDisplayFormatRegex = RegExp(/^\+?\d{1,2}(?:\.\d)?$/);

    const { disqualified, reason, comments, nofinish, hcp, hci } = this.state;

    const err_comments = filter.isProfane(comments);
    if (err_comments) {
      this.setState({ err_comments }); // Keep separate error state for comments
      showSnackbar("Comments contain inappropriate language.");
      return;
    }
    this.setState({ err_comments: false }); // Reset if comments are clean

    // Validate Handicap Index (hci)
    // 1. Check the display format.
    //    Allow empty string to pass format test if it's considered valid (e.g. not submitted)
    //    but if it reaches here and it's empty, it will likely fail the parseFloat or range check depending on hcpConvertor.
    //    Assuming non-empty hci is required if submitted.
    if (hci.trim() === "" || !handicapDisplayFormatRegex.test(hci)) {
      this.setState({ err_hcp: true }); // Using err_hcp for hci validation as per existing pattern
      showSnackbar("Handicap Index format is invalid. Examples: +1.7, 10, 0.5");
      return;
    }

    // 2. Convert to actual numeric value for range checking.
    const actualHciString = hcpConvertor(hci); // e.g., hcpConvertor("+1.7") -> "-1.7"
    const actualHciValue = parseFloat(actualHciString);

    // 3. Check for NaN and the numeric range.
    if (isNaN(actualHciValue) || actualHciValue < -10 || actualHciValue > 60) {
      this.setState({ err_hcp: true }); // Using err_hcp for hci validation
      showSnackbar("Handicap Index value is invalid or out of range (-10.0 to 60.0).");
      return;
    }

    // If all validations pass for hci
    this.setState({ err_hcp: false });

    const player = this.getPlayer();
    const game = this.getGame();

    if (player && game) {
      // Ensure player and game are not null
      this.props.dangerouslyUpdateScore(
        game._id,
        player._id,
        player.scoreId,
        {
          uholes: this.setUholesFromChangedGrosses(game.players[player._id]),
          reason,
          comments: comments.trim(),
          nofinish,
          disqualified,
          hcp: hcpConvertor(hcp), // Convert display hcp to storable/calculable format
          hci: hcpConvertor(hci), // Convert display hci to storable/calculable format
          playerId: player._id,
        },
        game.players[player._id].holes,
        err => {
          if (!err) {
            this.props.closeDialog();
          }
          // If there's an error from the API, it's typically handled by a global error handler
          // or a snackbar shown by the action itself.
        },
      );
    } else {
      showSnackbar("Player or game data is missing. Cannot submit score.");
      // console.error("Player or game data is missing in _submitForm");
    }
  };

  setUholesFromChangedGrosses = (player: any) => {
    const uholes = { ...player.uholes };
    Object.keys(player.holes).forEach(key => {
      if (player.holes[key].gross) {
        const grosses = Object.keys(player.uholes[key].grosses);
        if (grosses.length === 1) {
          uholes[key].grosses[grosses[0]] = player.holes[key].gross;
        }
      }
    });

    return uholes;
  };

  _showGrossPicker = (param: HoleParam) => {
    this.setState({
      openPickerDialog: true,
      pickerHoleParams: param,
    });
  };

  calculateHoleNumber(number: number) {
    const scoreCard = this.getScoreCard();
    if (!scoreCard || !scoreCard.name) return number;
    const name = scoreCard.name.toLowerCase();
    const { holesNumber } = scoreCard.course;
    if (name.includes("back")) {
      return number + holesNumber;
    } else if (name.includes("middle")) {
      return number + 6;
    } else return number;
  }

  renderRow = (param: HoleParam, holes: any, uholes: any) => {
    const { classes } = this.props;
    const { selectedScorerId } = this.state;
    const player = this.getPlayer();
    const game = this.getGame();
    const isCombined = isCombinedGame(game.competition);
    const scorerPlayer = game.players[selectedScorerId];
    const isScorerPointAvailable = isCombined ? false : scorerPlayer.holes[param.number];

    if (!player) return;
    const verifyStatus = this.checkIsVerified(player, param);
    const holeScore = holes?.[param.number];
    const holeUholes = uholes?.[param.number];
    const grossValue =
      (holeScore && holeScore.gross) ||
      (holeUholes && holeUholes.grosses && holeUholes.grosses[selectedScorerId]) ||
      "";

    return (
      <StyledTableRow>
        <TightBodyCell className={classes.holeCell}>{this.calculateHoleNumber(param.number)}</TightBodyCell>
        <TightBodyCell className={classes.numCell}>{param.yards}</TightBodyCell>
        <TightBodyCell className={classes.numCell}>{param.si}</TightBodyCell>
        <TightBodyCell className={classes.numCell}>{param.par}</TightBodyCell>
        <TightBodyCell className={classes.playerCell}>
          <div className={classes.grossCell}>
            <span>{grossValue}</span>
            <IconButton
              size="small"
              className={classes.editBtn}
              onClick={() => this._showGrossPicker(param)}
              aria-label={`Edit hole ${param.number} gross`}
            >
              <Edit fontSize="small" />
            </IconButton>
          </div>
        </TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.playerCell}`}>
          {holes && holes[param.number] ? player.points.holes?.[param.number]?.nett ?? 0 : 0}
        </TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.playerCell}`}>
          {player.points.holes?.[param.number]?.point ?? 0}
        </TightBodyCell>
        <TightBodyCell className={classes.verifyCell}>{this.renderAutoVerified(verifyStatus)}</TightBodyCell>
        <TightBodyCell className={classes.verifyCell}>{this.renderManualyVerified(verifyStatus)}</TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.markerCell}`}>
          {isScorerPointAvailable ? scorerPlayer.holes[param.number].gross : ""}
        </TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.markerCell}`}>
          {isScorerPointAvailable ? scorerPlayer.points.holes[param.number].nett : 0}
        </TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.markerCell}`}>
          {isScorerPointAvailable ? scorerPlayer.points.holes[param.number].point : 0}
        </TightBodyCell>
      </StyledTableRow>
    );
  };

  canOrganizerEditGross = (verifyStatus: VerifyStatus, holes: any, uholes: any, holeNumber: number) => {
    const { selectedScorerId } = this.state;
    if (verifyStatus === VerifyStatus.VERIFIED) return false;
    if (verifyStatus === VerifyStatus.UNVERIFIED) return false;
    if (_.isEmpty(uholes) || uholes[holeNumber]?.grosses?.[selectedScorerId]) return true;
    return false;
  };
  checkIsVerified = (player: Player, holesParams: HoleParam) => {
    if (!player.holes) return VerifyStatus.UNVERIFIED;
    if (!player.holes[holesParams.number]) return VerifyStatus.UNVERIFIED;
    if (!player.holes[holesParams.number].gross) return VerifyStatus.UNVERIFIED;
    const holeUholes = player.uholes?.[holesParams.number];
    if (holeUholes?.grosses && Object.values(holeUholes.grosses).length > 1) return VerifyStatus.VERIFIED;
    return VerifyStatus.MANUALY_VERIFIED;
  };

  renderAutoVerified = (verifyStatus: VerifyStatus) =>
    verifyStatus === VerifyStatus.VERIFIED ? <Check style={{ color: "#33a136" }} /> : null;

  renderManualyVerified = (verifyStatus: VerifyStatus) =>
    verifyStatus === VerifyStatus.MANUALY_VERIFIED ? <Check style={{ color: "#ffaf0f" }} /> : null;

  renderSummeryRow = (title: string, holesParams: any, point: any, markerPoint: any) => {
    const { classes } = this.props;
    const player = this.getPlayer();
    if (!player) return null;
    return (
      <StyledTableRow className={classes.summaryRow}>
        <TightHeaderCell className={classes.summaryLabel}>{title}</TightHeaderCell>
        <TightBodyCell className={classes.numCell}>{this.summation(holesParams, "yards")}</TightBodyCell>
        <TightHeaderCell className={classes.summaryLabel}>{title}</TightHeaderCell>
        <TightBodyCell className={classes.numCell}>{this.summation(holesParams, "par")}</TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.playerCell}`}>{point.totalGross}</TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.playerCell}`}>{point.totalNett}</TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.playerCell}`}>{point.totalPoint}</TightBodyCell>
        <TightBodyCell />
        <TightBodyCell />
        <TightBodyCell className={`${classes.numCell} ${classes.markerCell}`}>{markerPoint?.totalGross}</TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.markerCell}`}>{markerPoint?.totalNett}</TightBodyCell>
        <TightBodyCell className={`${classes.numCell} ${classes.markerCell}`}>{markerPoint?.totalPoint}</TightBodyCell>
      </StyledTableRow>
    );
  };

  render_Table(
    combination: number,
    holesParams: HoleParam[],
    holes: any,
    player: Player,
    scorerPlayer: Player,
    uholes: any,
  ) {
    if (!holes) holes = {};

    switch (holesParams.length) {
      case 12:
        return this.render_Table_2x6(holesParams, holes, player, scorerPlayer, uholes);
      case 18:
        if (combination === 2) {
          return this.render_Table_2x9(holesParams, holes, player, scorerPlayer, uholes);
        } else {
          return this.render_Table_3x6(holesParams, holes, player, scorerPlayer, uholes);
        }
      case 9:
      case 6:
        return this.render_Table_6_or_9(holesParams, holes, player, scorerPlayer, uholes);
      default:
        return null;
    }
  }
  render_Table_6_or_9 = (holesParams: HoleParam[], holes: any, player: Player, scorerPlayer: Player, uholes: any) => {
    return (
      <TableBody>
        {holesParams.map(param => this.renderRow(param, holes, uholes))}
        {this.renderSummeryRow("Total", holesParams, player.points, scorerPlayer.points)}
      </TableBody>
    );
  };
  render_Table_2x9 = (holesParams: HoleParam[], holes: any, player: Player, scorerPlayer: Player, uholes: any) => {
    const OUT = this.renderSummeryRow(
      "OUT",
      holesParams.slice(0, 9),
      player.points.summary[1],
      scorerPlayer.points.summary[1],
    );
    return (
      <TableBody>
        {holesParams.slice(0, 9).map(param => this.renderRow(param, holes, uholes))}
        {OUT}
        {holesParams.slice(9).map(param => this.renderRow(param, holes, uholes))}
        {this.renderSummeryRow("IN", holesParams.slice(9), player.points.summary[3], scorerPlayer.points.summary[3])}
        {OUT}
        {this.renderSummeryRow("Total", holesParams, player.points, scorerPlayer.points)}
      </TableBody>
    );
  };
  render_Table_3x6 = (holesParams: HoleParam[], holes: any, player: Player, scorerPlayer: Player, uholes: any) => {
    const OUT = this.renderSummeryRow(
      "OUT",
      holesParams.slice(0, 6),
      player.points.summary[0],
      scorerPlayer.points.summary[0],
    );
    return (
      <TableBody>
        {holesParams.slice(0, 6).map(param => this.renderRow(param, holes, uholes))}
        {OUT}
        {holesParams.slice(6, 12).map(param => this.renderRow(param, holes, uholes))}
        {this.renderSummeryRow(
          "MIDDLE",
          holesParams.slice(6, 12),
          player.points.summary[2],
          scorerPlayer.points.summary[2],
        )}
        {holesParams.slice(12).map(param => this.renderRow(param, holes, uholes))}
        {this.renderSummeryRow("IN", holesParams.slice(12), player.points.summary[4], scorerPlayer.points.summary[4])}
        {OUT}
        {this.renderSummeryRow("Total", holesParams, player.points, scorerPlayer.points)}
      </TableBody>
    );
  };
  render_Table_2x6 = (holesParams: HoleParam[], holes: any, player: Player, scorerPlayer: Player, uholes: any) => {
    const OUT = this.renderSummeryRow(
      "OUT",
      holesParams.slice(0, 6),
      player.points.summary[0],
      scorerPlayer.points.summary[0],
    );
    return (
      <TableBody>
        {holesParams.slice(0, 6).map(param => this.renderRow(param, holes, uholes))}
        {OUT}
        {holesParams.slice(6).map(param => this.renderRow(param, holes, uholes))}
        {this.renderSummeryRow("IN", holesParams.slice(6), player.points.summary[1], scorerPlayer.points.summary[1])}
        {OUT}
        {this.renderSummeryRow("Total", holesParams, player.points, scorerPlayer.points)}
      </TableBody>
    );
  };

  renderTopSection(game: Game) {
    const { classes } = this.props;
    const player = this.getPlayer();
    if (!player) return;
    const scoreCard = this.getScoreCard();
    const { selectedScorerId } = this.state;
    const isCombined = isCombinedGame(game.competition);
    const gameDone = game.state === GState.Done;
    const tournamentNames =
      game.tournaments && game.tournaments.length > 0
        ? game.tournaments.map((t: any) => t.name).filter(Boolean).join(", ")
        : "Standalone";

    return (
      <div className={classes.metaGrid}>
        <MetaField label="Club Name" classes={classes} className={classes.metaFieldClub}>
          {game.course.club.name}
        </MetaField>
        <MetaField label="Course" classes={classes} className={classes.metaFieldCourse}>
          {game.course.name}
        </MetaField>
        <MetaField label="Date" classes={classes}>
          {Moment(game.date).format(Config.DATE_DISPLAY_FORMAT)}
        </MetaField>
        <MetaField label="Holes" classes={classes}>
          {game.course.holesNumber}
        </MetaField>
        <MetaField label="Start Time" classes={classes}>
          {Moment(game.date).format(Config.TIME_DISPLAY_FORMAT)}
        </MetaField>
        <MetaField label="Finish Time" classes={classes}>
          {player.updateDate ? Moment(player.updateDate).format(Config.TIME_DISPLAY_FORMAT) : "..."}
        </MetaField>
        <MetaField label="Format" classes={classes}>
          {typeof game.competition === "object" ? game.competition.scoringFormat : "undefined"}
        </MetaField>
        <MetaField label="Tees Used" classes={classes}>
          {scoreCard ? scoreCard.teeColor : "undefined"}
        </MetaField>
        <MetaField label="Game Name" classes={classes} className={classes.metaFieldName}>
          {game.name}
        </MetaField>
        <MetaField label="Game Code" classes={classes}>
          <GameCodeCapsule code={game.code} />
        </MetaField>
        <MetaField label="Tournament Name" classes={classes} wide>
          {tournamentNames}
        </MetaField>
        <MetaField label="Player" classes={classes} className={classes.metaFieldPlayer}>
          <PlayerName isGuest={player.guest} name={player.name} lastName={player.lastName} />
        </MetaField>
        <MetaField label="PH" classes={classes}>
          <div
            contentEditable={true}
            suppressContentEditableWarning
            onInput={this._handleHandicapChange}
            className={classes.hcpEdit}
          >
            {getHandicapDisplay(player.playingHcp)}
          </div>
        </MetaField>
        <MetaField label="HI" classes={classes}>
          <div
            contentEditable={!(game.state === GState.Done)}
            suppressContentEditableWarning
            onInput={this._handleHandicapIndexChange}
            className={gameDone ? `${classes.hcpEdit} ${classes.hcpEditDisabled}` : classes.hcpEdit}
          >
            {this.state.hci}
          </div>
        </MetaField>
        {isCombined ? null : (
          <MetaField label="Scorer" classes={classes} className={classes.metaFieldScorer}>
            <Select
              variant="outlined"
              margin="dense"
              value={selectedScorerId}
              onChange={this.handleChangeScorer}
              className={classes.scorerSelect}
            >
              {Object.values(game.players).map((listedPlayer: any) => {
                return (
                  <MenuItem key={listedPlayer._id} value={listedPlayer._id}>
                    <PlayerName isGuest={listedPlayer.guest} name={listedPlayer.name} lastName={listedPlayer.lastName} />
                  </MenuItem>
                );
              })}
            </Select>
          </MetaField>
        )}
      </div>
    );
  }
  renderActions() {
    const { classes } = this.props;
    const { comments, reason, nofinish, disqualified } = this.state;
    return (
      <div className={classes.actions}>
        <TextInput
          className={classes.comments}
          label="Comments"
          multiline
          fullWidth
          rows={4}
          value={comments}
          defaultValue=""
          name={"comments"}
          onChange={this._handleCommentsChange}
          variant="outlined"
        />
        <div className={classes.flags}>
          <FormControlLabel
            control={
              <Switch
                checked={nofinish}
                onChange={this._handleSwitchChange("nofinish")}
                name="checkedB"
                color="primary"
              />
            }
            label="DNF, DNP, WD"
          />
          <FormControlLabel
            control={
              <Switch
                checked={disqualified}
                onChange={this._handleSwitchChange("disqualified")}
                name="checkedB"
                color="primary"
              />
            }
            label="Disqualified"
          />
          {disqualified ? (
            <FormControl fullWidth className={classes.reason}>
              <InputLabel id="reason">Reason</InputLabel>
              <Select id="reason" value={reason} onChange={this._handleChangeReason}>
                <MenuItem value={"Failure to attend"}>Failure to attend</MenuItem>
                <MenuItem value={"Wrong score submissio"}>Wrong score submissio</MenuItem>
                <MenuItem value={"Wrong handicap"}>Wrong handicap</MenuItem>
                <MenuItem value={"Breach of rules"}>Breach of rules</MenuItem>
                <MenuItem value={"Leaving game"}>Leaving game</MenuItem>
                <MenuItem value={"Gross misconduct"}>Gross misconduct</MenuItem>
              </Select>
            </FormControl>
          ) : null}
        </div>
        <div className={classes.actionButtons}>
          <Button color={"primary"} variant={"contained"} onClick={this._submitForm}>
            Submit Changes
          </Button>
          <Button color={"primary"} variant={"outlined"} onClick={this.props.closeDialog}>
            Cancel
          </Button>
        </div>
      </div>
    );
  }
  renderGrossPickerDialog() {
    const { openPickerDialog, pickerHoleParams } = this.state;
    const player = this.getPlayer();
    if (!player) return;
    return (
      <Dialog open={openPickerDialog} onBackdropClick={() => this.setState({ openPickerDialog: false })}>
        <GrossPickerDialog
          gameId={this.props.game._id}
          holeNumber={pickerHoleParams.number}
          teamId={player.team?._id}
          onSelect={(gross: any, dnfSelected: boolean, p?: Player) => {
            this._handleGrossChange(p || null, pickerHoleParams.number, gross, dnfSelected);
            this.setState({ openPickerDialog: false });
          }}
        />
      </Dialog>
    );
  }

  render() {
    const { classes, loading } = this.props;
    const { selectedScorerId } = this.state;
    const game = this.getGame();
    if (!game) return null;
    const { holesParams, combination } = this.getScoreCard()!;
    if (!holesParams) return null;
    const player = this.getPlayer();
    if (!player) return <p>Player Not found</p>;
    const scorerPlayer = game.players[selectedScorerId];
    const holes = player.holes;
    const uholes = player.uholes;
    return (
      <Paper className={classes.paper} square elevation={0}>
        <header className={classes.header}>
          <div className={classes.headerText}>
            <Typography component="h1" className={classes.title}>
              Submission card
            </Typography>
            <Typography component="p" className={classes.subtitle}>
              <PlayerName isGuest={player.guest} name={player.name} lastName={player.lastName} />
              <span className={classes.phMark}>PH {getHandicapDisplay(player.playingHcp)}</span>
            </Typography>
          </div>
          <IconButton className={classes.closeBtn} onClick={this.props.closeDialog} aria-label="Close">
            <Close />
          </IconButton>
        </header>
        <div className={classes.body}>
          {this.renderTopSection(game)}
          <TableContainer className={classes.tableWrap}>
            <Table size={"small"} className={classes.scoreTable}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.groupHead} colSpan={4} />
                  <TableCell className={`${classes.groupHead} ${classes.playerGroupHead}`} colSpan={3}>
                    Player
                  </TableCell>
                  <TableCell className={`${classes.groupHead} ${classes.verifyGroupHead}`} colSpan={2}>
                    Verified
                  </TableCell>
                  <TableCell className={`${classes.groupHead} ${classes.markerGroupHead}`} colSpan={3}>
                    Marker
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TightHeaderCell className={classes.colHead} align={"left"}>
                    Hole
                  </TightHeaderCell>
                  <TightHeaderCell className={classes.colHead} align={"left"}>
                    Yards
                  </TightHeaderCell>
                  <TightHeaderCell className={classes.colHead} align={"left"}>
                    SI
                  </TightHeaderCell>
                  <TightHeaderCell className={classes.colHead} align={"left"}>
                    Par
                  </TightHeaderCell>
                  <TightHeaderCell className={`${classes.colHead} ${classes.playerGroupHead}`} align={"left"}>
                    Gross
                  </TightHeaderCell>
                  <TightHeaderCell className={`${classes.colHead} ${classes.playerGroupHead}`} align={"left"}>
                    Nett
                  </TightHeaderCell>
                  <TightHeaderCell className={`${classes.colHead} ${classes.playerGroupHead}`} align={"left"} padding={"none"}>
                    Pts
                  </TightHeaderCell>
                  <TightHeaderCell className={`${classes.colHead} ${classes.verifyGroupHead}`} align={"left"}>
                    Auto Verified
                  </TightHeaderCell>
                  <TightHeaderCell className={`${classes.colHead} ${classes.verifyGroupHead}`} align={"left"}>
                    Manually Verified
                  </TightHeaderCell>
                  <TightHeaderCell className={`${classes.colHead} ${classes.markerGroupHead}`} align={"left"}>
                    Gross
                  </TightHeaderCell>
                  <TightHeaderCell className={`${classes.colHead} ${classes.markerGroupHead}`} align={"left"}>
                    Nett
                  </TightHeaderCell>
                  <TightHeaderCell className={`${classes.colHead} ${classes.markerGroupHead}`} align={"left"} padding={"none"}>
                    Pts
                  </TightHeaderCell>
                </TableRow>
              </TableHead>
              {this.render_Table(combination, holesParams, holes, player, scorerPlayer, uholes)}
            </Table>
          </TableContainer>
          {loading ? <LinearProgress /> : null}
          {this.renderActions()}
        </div>
        {this.renderGrossPickerDialog()}
      </Paper>
    );
  }
}

const styles = (theme: Theme) => {
  const line = theme.palette.divider;
  const headBg = theme.palette.grey[100];
  const playerWash = theme.palette.grey[50];

  return createStyles({
    paper: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      maxHeight: "100%",
      overflow: "hidden",
      width: "100%",
      maxWidth: "100%",
      margin: 0,
      borderRadius: 0,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      boxShadow: "none",
    },
    header: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: theme.spacing(2),
      padding: theme.spacing(2, 2, 1.5),
      borderBottom: `1px solid ${line}`,
      backgroundColor: theme.palette.grey[50],
      flexShrink: 0,
    },
    headerText: {
      minWidth: 0,
    },
    title: {
      margin: 0,
      fontWeight: 600,
      fontSize: "1.25rem",
      letterSpacing: "-0.02em",
      lineHeight: 1.25,
      color: theme.palette.text.primary,
    },
    subtitle: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "baseline",
      gap: theme.spacing(1),
      margin: theme.spacing(0.5, 0, 0),
      fontSize: "0.875rem",
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    phMark: {
      fontVariantNumeric: "tabular-nums",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    closeBtn: {
      margin: theme.spacing(-0.5, -0.5, 0, 0),
    },
    body: {
      flex: 1,
      minHeight: 0,
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      padding: theme.spacing(0, 2, 4),
      maxWidth: 1120,
      width: "100%",
      margin: "0 auto",
      boxSizing: "border-box",
    },
    metaGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
      gap: theme.spacing(1.5, 2),
      marginBottom: theme.spacing(2.5),
      paddingTop: theme.spacing(2),
      [`@media (max-width: 720px)`]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      },
    },
    metaField: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      minWidth: 0,
    },
    metaFieldWide: {
      gridColumn: "1 / -1",
    },
    metaFieldClub: {
      gridColumn: "span 2",
      [`@media (max-width: 720px)`]: {
        gridColumn: "span 2",
      },
    },
    metaFieldCourse: {
      gridColumn: "span 2",
    },
    metaFieldName: {
      gridColumn: "span 3",
      [`@media (max-width: 720px)`]: {
        gridColumn: "span 2",
      },
    },
    metaFieldPlayer: {
      gridColumn: "span 2",
    },
    metaFieldScorer: {
      gridColumn: "span 2",
    },
    metaLabel: {
      fontSize: "0.6875rem",
      fontWeight: 600,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      color: theme.palette.text.secondary,
      lineHeight: 1.3,
    },
    metaValue: {
      fontSize: "0.9375rem",
      fontWeight: 600,
      lineHeight: 1.4,
      color: theme.palette.text.primary,
      overflowWrap: "anywhere",
    },
    hcpEdit: {
      minWidth: 40,
      width: 64,
      height: 32,
      boxSizing: "border-box",
      borderRadius: theme.shape.borderRadius,
      padding: "0 8px",
      display: "inline-block",
      lineHeight: "32px",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.grey[400]}`,
      color: theme.palette.text.primary,
      cursor: "text",
      textAlign: "center",
      fontVariantNumeric: "tabular-nums",
      fontWeight: 600,
      outline: "none",
      "&:focus": {
        borderColor: theme.palette.primary.main,
      },
    },
    hcpEditDisabled: {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.text.disabled,
      cursor: "not-allowed",
    },
    scorerSelect: {
      marginTop: 0,
      backgroundColor: theme.palette.background.paper,
      "& .MuiOutlinedInput-input": {
        paddingTop: 8,
        paddingBottom: 8,
      },
    },
    tableWrap: {
      overflow: "visible",
      border: `1px solid ${line}`,
      borderRadius: 0,
      backgroundColor: theme.palette.background.paper,
    },
    scoreTable: {
      minWidth: 720,
      borderCollapse: "separate",
      borderSpacing: 0,
      "& .MuiTableCell-root": {
        borderColor: line,
      },
      "& thead": {
        position: "sticky",
        top: 0,
        zIndex: 5,
        backgroundColor: headBg,
        boxShadow: `0 1px 0 ${line}`,
      },
    },
    groupHead: {
      position: "sticky",
      top: 0,
      zIndex: 6,
      height: 22,
      boxSizing: "border-box",
      fontSize: "0.6875rem",
      fontWeight: 600,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: theme.palette.text.secondary,
      backgroundColor: headBg,
      borderBottom: "none",
      padding: "4px 8px",
      lineHeight: 1.2,
    },
    colHead: {
      position: "sticky",
      top: 22,
      zIndex: 5,
      fontSize: "0.75rem",
      fontWeight: 600,
      color: theme.palette.text.primary,
      backgroundColor: headBg,
      whiteSpace: "nowrap",
    },
    playerGroupHead: {
      backgroundColor: headBg,
      color: theme.palette.primary.dark,
    },
    markerGroupHead: {
      backgroundColor: headBg,
    },
    verifyGroupHead: {
      backgroundColor: headBg,
    },
    holeCell: {
      fontWeight: 600,
      fontVariantNumeric: "tabular-nums",
      color: theme.palette.text.primary,
    },
    numCell: {
      fontVariantNumeric: "tabular-nums",
    },
    playerCell: {
      backgroundColor: playerWash,
    },
    markerCell: {},
    verifyCell: {
      textAlign: "center",
      paddingLeft: 4,
      paddingRight: 4,
    },
    grossCell: {
      display: "inline-flex",
      alignItems: "center",
      gap: 2,
      fontVariantNumeric: "tabular-nums",
      fontWeight: 600,
    },
    editBtn: {
      padding: 4,
    },
    summaryRow: {
      backgroundColor: `${headBg} !important`,
      "& td, & th": {
        fontWeight: 600,
        fontVariantNumeric: "tabular-nums",
      },
    },
    summaryLabel: {
      fontWeight: 700,
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      fontSize: "0.75rem",
      color: theme.palette.text.primary,
    },
    actions: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      marginTop: theme.spacing(3),
      padding: theme.spacing(2),
      border: `1px solid ${line}`,
      borderRadius: 8,
      backgroundColor: theme.palette.background.paper,
    },
    comments: {
      margin: 0,
    },
    flags: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: theme.spacing(1),
    },
    reason: {
      marginTop: theme.spacing(1),
      minWidth: 220,
    },
    actionButtons: {
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(1.5),
    },
    inline: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
    smallInput: {
      width: 32,
    },
    actionButton: {
      margin: theme.spacing(1),
    },
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
  });
};
const mapStateToProps = (state: GlobalState) => {
  const { user } = state.auth;
  const { loading } = state.general;
  return {
    user,
    loading,
  };
};

export default connect(mapStateToProps, {
  dangerouslyUpdateScore: GamesActions.dangerouslyUpdateScore,
})(withStyles(styles)(ScoreCardSubmition));
